import { Link } from "react-router-dom";
import { useSite, usePageMeta } from "@/lib/content";
import { fileUrl } from "@/lib/api";
import { MaskLines, Reveal } from "@/components/site/Reveal";

export default function About() {
  usePageMeta(
    "About — SEIMEN DEXTER | Hard / Industrial Techno",
    "SEIMEN DEXTER is a Hard / Industrial Techno DJ and producer from Mannheim, Germany. Raw industrial pressure, hard driving techno, euphoric rave energy — around 165 BPM."
  );
  const { data: site } = useSite();
  return (
    <div className="px-5 md:px-10 pt-28 md:pt-40 pb-24 md:pb-36">
      <h1 className="font-display leading-[0.92] text-[14vw] md:text-[8vw] mb-14 md:mb-24">
        <MaskLines
          lines={[
            "THIS IS",
            <span key="sd" className="text-bloodbright">SEIMEN DEXTER.</span>,
          ]}
        />
      </h1>
      <div className="grid gap-12 md:grid-cols-12">
        <Reveal className="md:col-span-5" y={40}>
          <div className="md:sticky md:top-28 overflow-hidden border border-line">
            <img
              src={fileUrl(site?.about_image_url || "/assets/artist_live_01.webp")}
              alt="SEIMEN DEXTER at the decks"
              loading="lazy"
              className="w-full aspect-[3/4] object-cover"
              draggable="false"
            />
          </div>
        </Reveal>
        <div className="md:col-span-7 flex flex-col justify-center">
          <Reveal>
            <p className="kicker mb-6">HARD / INDUSTRIAL TECHNO — MANNHEIM / GERMANY — 165 BPM</p>
            <p className="max-w-xl text-lg md:text-xl text-white/80 leading-relaxed">{site?.bio_text}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-14 border-l-2 border-blood pl-6 md:pl-8">
              <p className="font-display text-5xl md:text-6xl leading-[1.02]">
                {site?.philosophy_line1}
                <br />
                {site?.philosophy_line2}
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-14 grid grid-cols-3 border border-line divide-x divide-line text-center md:text-left">
              {[
                ["165", "BPM"],
                ["MANNHEIM", "GERMANY"],
                ["HARD", "INDUSTRIAL"],
              ].map(([a, b], i) => (
                <div key={i} className="px-4 py-6">
                  <p className="font-display text-2xl md:text-3xl">{a}</p>
                  <p className="kicker mt-1">{b}</p>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <Link data-testid="about-booking-cta" to="/booking" className="btn-primary mt-14">
              BOOKING REQUEST
            </Link>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
